import { Squares2X2Icon, ListBulletIcon } from '@heroicons/react/24/outline';

export type ViewMode = 'grid' | 'list';

interface ViewToggleProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

export function ViewToggle({ viewMode, onViewModeChange }: ViewToggleProps) {
  return (
    <div className="flex items-center bg-gray-100 dark:bg-gray-700 rounded-md p-1">
      <button
        type="button"
        onClick={() => onViewModeChange('grid')}
        className={`p-2 rounded ${
          viewMode === 'grid'
            ? 'bg-white dark:bg-gray-600 text-indigo-600 dark:text-indigo-400 shadow-sm'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
        }`}
        title="Grid view"
      >
        <Squares2X2Icon className="h-5 w-5" />
      </button>
      <button
        type="button"
        onClick={() => onViewModeChange('list')}
        className={`p-2 rounded ${
          viewMode === 'list'
            ? 'bg-white dark:bg-gray-600 text-indigo-600 dark:text-indigo-400 shadow-sm'
            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300'
        }`}
        title="List view"
      >
        <ListBulletIcon className="h-5 w-5" />
      </button>
    </div>
  );
}
